import {ConditionalType, OrderPlaceTabType} from '@px/enum/order';
import {CalculatorTabType} from '@px/enum/tab-pc';
import {OrderBookType} from '@px/enum/book';
import {PlaceOrderSide, TradeDataMode} from '@px/enum';
import {TpSlPriceType} from '@px/enum/perpetual';
import {storageUtil} from '@px/helper/storage';

interface Pos {
  x: number;
  y: number;
}

type OrderSide = 'Normal' | 'Down' | 'Up';
type OrderBy = 'combinationTurnoverEv' | 'closeEp' | 'changePercent';

interface MarketSort {
  orderSide: OrderSide;
  orderBy: OrderBy;
}

interface ContractStorage extends StorageObject {
  calculatorDialogPos: Pos;
  calculatorTabType: CalculatorTabType;
  placeOrderSide: PlaceOrderSide;
  placeOrderTabType: OrderPlaceTabType;
  cheapCopyPlaceOrderTabType: OrderPlaceTabType;
  conditionalType: ConditionalType;
  cheapCopyConditionalType: ConditionalType;
  orderBookType: OrderBookType;
  advancedIsShow: boolean;
  hideOtherSymbols: boolean;
  lastSymbol: string;
  quickPlaceMarketOrder: Pos;
  marketSort: MarketSort;
  hideTpslEntireInfo: boolean;
  hideTpslPartialInfo: boolean;
  tpSl: {tp: string; sl: string};
  riskEngineMode: boolean;
  timestamp: {ct: number; cheapToken: number};
}

const STORAGE_KEY = 'contract_storage';

export const contractStorage = {
  readContractStorage(): ContractStorage {
    return storageUtil.readStorageObject(STORAGE_KEY, createInitContractStorage());
  },

  updateContractStorage(kv: Partial<ContractStorage>) {
    storageUtil.writeStorageObject(STORAGE_KEY, {...contractStorage.readContractStorage(), ...kv});
  },
};

function createInitContractStorage(): ContractStorage {
  return {
    version: 1,
    calculatorDialogPos: null,
    calculatorTabType: CalculatorTabType.ProfitLoss,
    placeOrderSide: PlaceOrderSide.Right,
    placeOrderTabType: OrderPlaceTabType.Limit,
    cheapCopyPlaceOrderTabType: OrderPlaceTabType.Limit,
    conditionalType: ConditionalType.Limit,
    cheapCopyConditionalType: ConditionalType.Limit,
    orderBookType: OrderBookType.Stack,
    advancedIsShow: false,
    hideOtherSymbols: false,
    lastSymbol: '',
    quickPlaceMarketOrder: null,
    marketSort: {orderSide: 'Normal', orderBy: 'combinationTurnoverEv'},
    hideTpslEntireInfo: false,
    hideTpslPartialInfo: false,
    tpSl: {tp: TpSlPriceType.Roi, sl: TpSlPriceType.Roi},
    riskEngineMode: true,
    timestamp: {ct: 0, cheapToken: 0},
    tradeDataMode: TradeDataMode.List,
    pilotLastSymbol: '',
  };
}
